import { PROJECT_BACKLOG, request, success, failure } from "./utilities";
import {
  fetchProjectBackLogTasks,
  AddProjectBackLogTasks,
  AddBackLogTasksInMilestone,
  DeleteProjectBackLogTasks,
  moveToSprint,
} from "../api";
export function MoveToSprint(
  // projectId,
  taskId,
  // mileStoneId,
  data,
  token,
  moveToNext,
  Notification
) {
  return (dispatch) => {
    dispatch(request(PROJECT_BACKLOG.MOVE_BACKLOG_REQUEST));
    moveToSprint(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(success(PROJECT_BACKLOG.MOVE_BACKLOG_SUCCESS, taskId));
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) Notification(res.data.message, "success");
        } else {
          dispatch(
            failure(PROJECT_BACKLOG.MOVE_BACKLOG_FAILURE, res.data.message)
          );
          if (Notification) Notification(res.data.message, "error");
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_BACKLOG.MOVE_BACKLOG_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
export function getProjectBackLogTasks(project, token, responseErrorFunc) {
  return (dispatch) => {
    dispatch(request(PROJECT_BACKLOG.GET_PROJECT_BACKLOG_REQUEST));
    fetchProjectBackLogTasks(project, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(PROJECT_BACKLOG.GET_PROJECT_BACKLOG_SUCCESS, res.data.data)
          );
          if (responseErrorFunc) {
            responseErrorFunc(false);
          }
        } else {
          dispatch(
            failure(
              PROJECT_BACKLOG.GET_PROJECT_BACKLOG_FAILURE,
              res.data.message
            )
          );
          if (responseErrorFunc) {
            responseErrorFunc(true);
          }
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_BACKLOG.GET_PROJECT_BACKLOG_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
        if (responseErrorFunc) {
          responseErrorFunc(true);
        }
      }
    );
  };
}

export function AddProjectBackLogTask(data, token, moveToNext, Notification) {
  return (dispatch) => {
    dispatch(request(PROJECT_BACKLOG.ADD_PROJECT_BACKLOG_REQUEST));
    AddProjectBackLogTasks(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(PROJECT_BACKLOG.ADD_PROJECT_BACKLOG_SUCCESS, res.data.data)
          );
          if (moveToNext) moveToNext();
          if (Notification) Notification(res.data.message, "success");
        } else {
          dispatch(
            failure(
              PROJECT_BACKLOG.ADD_PROJECT_BACKLOG_FAILURE,
              res.data.message
            )
          );
          if (Notification) Notification(res.data.message, "error");
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_BACKLOG.ADD_PROJECT_BACKLOG_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function UpdateProjectBackLogTask(
  data,
  token,
  moveToNext,
  Notification
) {
  return (dispatch) => {
    dispatch(request(PROJECT_BACKLOG.EDIT_PROJECT_BACKLOG_REQUEST));
    AddProjectBackLogTasks(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(PROJECT_BACKLOG.EDIT_PROJECT_BACKLOG_SUCCESS, res.data.data)
          );

          if (moveToNext) {
            moveToNext();
          }
          if (Notification) Notification(res.data.message, "success");
        } else {
          dispatch(
            failure(
              PROJECT_BACKLOG.EDIT_PROJECT_BACKLOG_FAILURE,
              res.data.message
            )
          );
          if (moveToNext) {
            moveToNext();
          }
          if (Notification) Notification(res.data.message, "error");
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_BACKLOG.EDIT_PROJECT_BACKLOG_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function DeleteProjectBackLogTask(taskId, token, Notification) {
  return (dispatch) => {
    dispatch(request(PROJECT_BACKLOG.DELETE_PROJECT_BACKLOG_REQUEST));
    DeleteProjectBackLogTasks(taskId, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECT_BACKLOG.DELETE_PROJECT_BACKLOG_SUCCESS,
              res.data.data
            )
          );
          if (Notification) Notification(res.data.message, "success");
        } else {
          dispatch(
            failure(
              PROJECT_BACKLOG.DELETE_PROJECT_BACKLOG_FAILURE,
              res.data.message
            )
          );
          if (Notification) Notification(res.data.message, "error");
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_BACKLOG.DELETE_PROJECT_BACKLOG_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}

export function AddBackLogTaskInMilestone(data, token) {
  return (dispatch) => {
    dispatch(request(PROJECT_BACKLOG.ADD_TASK_IN_MILESTONE_REQUEST));
    AddBackLogTasksInMilestone(data, token).then(
      (res) => {
        if (res.data.status === 1) {
          dispatch(
            success(
              PROJECT_BACKLOG.ADD_TASK_IN_MILESTONE_SUCCESS,
              res.data.data
            )
          );
        } else {
          dispatch(
            failure(
              PROJECT_BACKLOG.ADD_TASK_IN_MILESTONE_FAILURE,
              res.data.message
            )
          );
        }
      },
      (error) => {
        dispatch(
          failure(
            PROJECT_BACKLOG.ADD_TASK_IN_MILESTONE_FAILURE,
            error &&
              error.response &&
              error.response.data &&
              error.response.data.title
              ? error.response.data.title
              : error.message
          )
        );
      }
    );
  };
}
